import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { articles } from '@/mocks/articles';

export default function ArticlesSection() {
  const { t, i18n } = useTranslation();
  const lang = (i18n.language || 'en').split('-')[0];

  const localized = (value: { en: string; pl: string; es: string; fr: string }) =>
    value[lang as 'en' | 'pl' | 'es' | 'fr'] || value.en;

  return (
    <section className="border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20 lg:px-8">
        <div className="flex flex-col items-center text-center">
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
            {t('home.articlesTitle')}
          </h2>
          <p className="mt-3 max-w-2xl text-sm text-foreground-600 md:text-base">{t('home.articlesSub')}</p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {articles.map((a) => (
            <Link
              key={a.slug}
              to={`/article/${a.slug}`}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
            >
              <div className="relative h-44 w-full overflow-hidden">
                <img
                  src={a.image}
                  alt={localized(a.title)}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-3 py-1 text-xs font-semibold text-primary-700 backdrop-blur">
                  {a.category}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <h3 className="text-base font-semibold leading-snug text-foreground-950">{localized(a.title)}</h3>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{localized(a.desc)}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-4">
                  <span className="flex items-center gap-2 text-xs text-foreground-500">
                    <span className="flex h-4 w-4 items-center justify-center">
                      <i className="ri-time-line text-sm"></i>
                    </span>
                    {a.readingTime}
                  </span>
                  <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-600">
                    {t('common.readMore')}
                    <span className="flex h-4 w-4 items-center justify-center transition-transform group-hover:translate-x-0.5">
                      <i className="ri-arrow-right-line text-base"></i>
                    </span>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}